import { create } from 'zustand'

export interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

export function isIos() {
  return /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase())
}

export function isDesktopSafari() {
  const ua = window.navigator.userAgent
  return /^((?!chrome|android|crios|fxios|edg|opr).)*safari/i.test(ua) && !isIos()
}

export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as unknown as { standalone?: boolean }).standalone === true
  )
}

interface PwaInstallState {
  deferredPrompt: BeforeInstallPromptEvent | null
  installed: boolean
}

// ponytail: beforeinstallprompt fires once per page load, so we capture it in a
// module-level store rather than component state, so any screen (auto-banner or
// Settings) can trigger the same native install dialog later.
export const usePwaInstallStore = create<PwaInstallState>(() => ({
  deferredPrompt: null,
  installed: isStandalone(),
}))

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  usePwaInstallStore.setState({ deferredPrompt: e as BeforeInstallPromptEvent })
})

window.addEventListener('appinstalled', () => {
  usePwaInstallStore.setState({ deferredPrompt: null, installed: true })
})
